import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download',
  template: `
    <div class="container">
      <div class="logo">Montra Connect</div>
      <h2>Opening in the App</h2>
      <div class="loader"></div>
      <p>
        If you don't have the app installed, you will be redirected to the App
        Store or Play Store shortly.
      </p>
      <a href="#" id="manual-link" class="btn" (click)="openStore()"
        >Open App manually</a
      >
    </div>
  `,
  styleUrls: ['./app-download.component.scss'],
})
export class AppDownloadComponent implements OnInit {
  ngOnInit() {
    this.openStore();
  }

  openStore() {
    const queryParams = window.location.search;
    const userAgent = navigator.userAgent;
    const currentHost = window.location.hostname;
    // Detect if environment is QA based on hostname
    const isQA = currentHost.includes('qa-myev.montraelectric.com');

    // App scheme (QA app scheme for QA domain, Prod app scheme for Prod domain)
    const appScheme = isQA ? 'in.montra.connect.qa' : 'in.montra.connect';

    // Store fallbacks are always the Production stores
    const appStoreUrl =
      'https://apps.apple.com/in/app/montra-connect/id6739263816';
    const playStoreUrl =
      'https://play.google.com/store/apps/details?id=in.montra.connect&hl=en_IN';

    let targetAppUrl = '';
    let fallbackUrl = '';

    // Determine platform and configure scheme and store URL
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      // iOS Devices
      targetAppUrl = `${appScheme}://referral${queryParams}`;
      fallbackUrl = appStoreUrl;
    } else if (/android/i.test(userAgent)) {
      // Android Devices
      targetAppUrl = `${appScheme}://referral${queryParams}`;
      fallbackUrl = playStoreUrl;
    } else {
      // Desktop fallback
      fallbackUrl = 'https://www.montraelectric.com';
    }

    // Auto-redirect sequence
    if (targetAppUrl) {
      // Try opening with custom scheme
      window.location.href = targetAppUrl;

      // If the app is not installed, custom scheme won't handle the request.
      // After 2 seconds, redirect to the store.
      setTimeout(() => {
        window.location.href = fallbackUrl;
      }, 3000);
    } else {
      // Default store fallback
      window.location.href = fallbackUrl;
    }
  }
}
